/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createTheming } from '@callstack/react-theme-provider';

import { palette } from './color.palette';

export const themeConfig = {
  colors: {
    mainBackground: palette?.grey,
    mainForeground: palette?.black,

    toastSuccess: palette?.greenDark,
    toastError: palette?.orangePrimary,

    primary: palette?.greenPrimary,
    secondary: palette?.greenSecondary,
    secondaryAlt: palette?.greenLight,

    headerBorderColor: palette?.greyDark,

    primaryCardBackground: palette['blue-2'],
    secondaryCardBackground: palette?.white,

    primaryButtonBackground: palette?.orangePrimary,
    primaryCardText: palette.white,
    secondaryCardText: palette['blue-2'],
    primaryText: palette['blue-2'],
    secondaryText: palette.white,
    primaryTimelineTag: palette?.greenLightDark,
    primaryDot: palette?.paleGreen,

    ...palette,
  },
};

const { ThemeProvider, withTheme, useTheme } = createTheming(themeConfig);

export { ThemeProvider, withTheme, useTheme };
